var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.createChat}},[_vm._v(_vm._s(_vm.btnText))])}
var staticRenderFns = []

export { render, staticRenderFns }